
import React, { useState } from 'react';
import './App.css';

function App() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImg, setLightboxImg] = useState(null);

  const openLightbox = (img) => {
    setLightboxImg(img);
    setLightboxOpen(true);
  };
  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxImg(null);
  };
  // Static list of article images
  const articleImages = [
    { url: '/articles/1000000596.jpg', name: '1000000596.jpg' },
    { url: '/articles/1000000593.jpg', name: '1000000593.jpg' },
    { url: '/articles/1000000590.jpg', name: '1000000590.jpg' },
    { url: '/articles/1000000611.jpg', name: '1000000611.jpg' },
    { url: '/articles/1000000605.jpg', name: '1000000605.jpg' },
    { url: '/articles/1000000617.jpg', name: '1000000617.jpg' },
    { url: '/articles/1000000638.jpg', name: '1000000638.jpg' },
    { url: '/articles/1000000635.jpg', name: '1000000635.jpg' },
    { url: '/articles/IMG-20250919-WA0014.jpg', name: 'IMG-20250919-WA0014.jpg' },
    { url: '/articles/1000000614.jpg', name: '1000000614.jpg' },
  { url: '/articles/1000000608.jpg', name: '1000000608.jpg' },
  { url: '/articles/100000059900.jpg', name: '100000059900.jpg' }
  ];
  // Helper for bilingual label
  const Bilingual = ({ fr, ar, center, frColor }) => (
    <div style={{ display: 'flex', justifyContent: center ? 'center' : 'space-between', alignItems: 'center', flexDirection: 'row', width: '100%' }}>
      {center ? (
        <>
          {ar && <span style={{ textAlign: 'center', fontWeight: 'bold', marginRight: 16 }}>{ar}</span>}
          <span style={{ display: 'inline-block', width: ar ? 18 : 0 }}></span>
          <span style={{ textAlign: 'center', color: frColor || '#555', marginLeft: 16, fontWeight: 'bold' }}>{fr.replace(/ *:$/, '')}</span>
        </>
      ) : (
        <>
          <span style={{ textAlign: 'right', flex: 1, fontWeight: 'bold' }}>{ar}</span>
          <span style={{ width: 60 }}></span>
          <span style={{ textAlign: 'left', flex: 1, color: frColor || '#555' }}>{fr.replace(/ *:$/, '')}</span>
        </>
      )}
    </div>
  );
  const [form, setForm] = useState({
    name: '',
    phone: '',
    command: '',
    remarque: ''
  });
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Phone number must be exactly 10 digits
  const isPhoneValid = /^\d{10}$/.test(form.phone);
  const isFormValid = form.name && isPhoneValid && form.command;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch('https://backouss.onrender.com/sell', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      await res.json();
      setResponse("Merci ! Votre demande a été reçue. Nous vous contacterons bientôt.");
          setResponse("Merci ! Votre demande a été reçue. Nous vous contacterons bientôt."); // Set success message
          setShowModal(true); // Show modal on successful submission
      setForm({ name: '', phone: '', command: '', remarque: '' }); // Clear form
        setTimeout(() => setResponse(null), 3500); // Hide message after 3.5s
    } catch (err) {
      setResponse("Erreur lors de l'envoi du formulaire");
    }
    setLoading(false);
  };

  // ...existing code...

  return (
  <div className="App" style={{ background: '#f8f9fa', minHeight: '100vh', padding: 0, direction: 'rtl', fontFamily: 'Tahoma, Arial, sans-serif' }}>
      <nav style={{
        width: '100%',
        background: '#2c3e50',
        padding: '0.5rem 0',
        marginBottom: '2rem',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      }}>
        <h2 style={{
          textAlign: 'center',
          fontSize: '2rem',
          color: '#fff',
          margin: 0,
          fontFamily: 'Georgia, Times New Roman, Times, serif',
          fontWeight: '600',
          letterSpacing: '2px',
          textShadow: '1px 1px 8px #2c3e50, 0 1px 0 #fff',
          flex: 1
        }}>
          Bienvenue à Tlemcen Impression
        </h2>
        <img
          src={process.env.PUBLIC_URL + '/logo-tlemcen.jpg'}
          alt="Logo Tlemcen Impression"
          style={{
            width: 80,
            height: 80,
            borderRadius: '12px',
            boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
            background: '#fff',
            objectFit: 'cover',
            border: '2px solid #2c3e50',
            marginRight: 30,
            marginLeft: 20
          }}
          onError={e => { e.target.onerror = null; e.target.src = 'https://via.placeholder.com/80?text=Logo'; }}
        />
      </nav>
      <form onSubmit={handleSubmit} style={{ maxWidth: 500, margin: 'auto', background: '#fff', padding: '2rem', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
            <Bilingual fr="Nom et Prénom :" ar="الاسم واللقب:" />
          </label><br />
          <input name="name" value={form.name} onChange={handleChange} required style={{ width: '100%', fontSize: '1.2rem', padding: '0.5rem', borderRadius: '5px', border: '1px solid #ccc' }} />
        </div>
        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
            <Bilingual fr="Numéro de téléphone :" ar="رقم الهاتف:" />
          </label><br />
          <input name="phone" value={form.phone} onChange={handleChange} required pattern="\d{10}" maxLength={10} style={{ width: '100%', fontSize: '1.2rem', padding: '0.5rem', borderRadius: '5px', border: isPhoneValid || !form.phone ? '1px solid #ccc' : '2px solid #e74c3c' }} />
            {!isPhoneValid && form.phone && (
              <span style={{ color: '#e74c3c', fontSize: '1rem', display: 'flex', justifyContent: 'space-between', flexDirection: 'row-reverse', width: '100%' }}>
                <span>يرجى إدخال رقم هاتف مكون من 10 أرقام.</span>
                <span style={{ color: '#555' }}>Veuillez entrer un numéro de téléphone à 10 numéros.</span>
              </span>
            )}
        </div>
        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
            <Bilingual fr="Commande :" ar="الطلب:" />
          </label><br />
          <input name="command" value={form.command} onChange={handleChange} required style={{ width: '100%', fontSize: '1.2rem', padding: '0.5rem', borderRadius: '5px', border: '1px solid #ccc' }} />
        </div>
        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
            <Bilingual fr="Remarque :" ar="ملاحظة:" />
          </label><br />
          <textarea name="remarque" value={form.remarque} onChange={handleChange} style={{ width: '100%', fontSize: '1.2rem', padding: '0.5rem', borderRadius: '5px', border: '1px solid #ccc', minHeight: '80px' }} />
        </div>
  <button type="submit" disabled={!isFormValid || loading} style={{ width: '60%', fontSize: '1.7rem', padding: '1rem', background: isFormValid ? '#2c3e50' : '#aaa', color: '#fff', border: 'none', borderRadius: '8px', cursor: isFormValid ? 'pointer' : 'not-allowed', textAlign: 'center', fontWeight: 'bold', letterSpacing: '1px', boxShadow: '0 2px 8px rgba(44,62,80,0.12)' }}>{loading ? <Bilingual fr="Envoi..." ar="" center frColor="#fff" /> : <Bilingual fr="Envoyer" ar="" center frColor="#fff" />}</button>
      </form>
      {loading && (
        <div style={{ textAlign: 'center', marginTop: '1rem', display: 'flex', flexDirection: 'row-reverse', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{ display: 'inline-block', marginRight: 8 }}>
            <svg width="28" height="28" viewBox="0 0 50 50">
              <circle cx="25" cy="25" r="20" fill="none" stroke="#2c3e50" strokeWidth="5" strokeDasharray="31.4 31.4" strokeLinecap="round">
                <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite" />
              </circle>
            </svg>
          </div>
          <Bilingual fr="Envoi en cours..." ar="جاري الإرسال..." />
        </div>
      )}
      {/* Success message below form removed, only modal will show for success */}
      {/* Show modal if needed */}
      {showModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(44,62,80,0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999 }}>
          <div style={{ background: '#fff', padding: '2rem 2.5rem', borderRadius: '12px', boxShadow: '0 2px 16px rgba(44,62,80,0.2)', textAlign: 'center' }}>
            <h3 style={{ color: '#27ae60', marginBottom: '1rem', textAlign: 'center' }}>Succès !</h3>
            <p style={{ fontSize: '1.2rem', color: '#2c3e50', textAlign: 'center' }}>Merci ! Votre demande a été reçue.<br />Nous vous contacterons bientôt.</p>
            <button onClick={() => setShowModal(false)} style={{ marginTop: '1.5rem', padding: '0.5rem 1.5rem', fontSize: '1.1rem', background: '#2c3e50', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', display: 'block', marginLeft: 'auto', marginRight: 'auto' }}>
              Fermer
            </button>
          </div>
        </div>
      )}
    {/* Organized article photos section at the bottom */}
    <div style={{ maxWidth: 800, margin: '40px auto 0', background: '#fff', padding: '2rem', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
      <h3 style={{ textAlign: 'center', marginBottom: '1.5rem', fontWeight: 'bold', color: '#2c3e50' }}>صور المقالات / Photos des articles</h3>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '20px', justifyContent: 'center' }}>
        {articleImages.map((img, idx) => (
          <div key={idx} style={{ border: '1px solid #eee', borderRadius: '8px', padding: '8px', background: '#fafafa', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <img src={img.url} alt={img.name} style={{ width: 140, height: 140, objectFit: 'cover', borderRadius: '6px', marginBottom: '8px', cursor: 'pointer', transition: 'box-shadow 0.2s' }} onClick={() => openLightbox(img)} />
          </div>
        ))}
      </div>

      {/* Lightbox modal for image zoom */}
      {lightboxOpen && lightboxImg && (
        <div onClick={closeLightbox} style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(44,62,80,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, cursor: 'zoom-out' }}>
          <img src={lightboxImg.url} alt={lightboxImg.name} style={{ maxWidth: '90vw', maxHeight: '90vh', borderRadius: '12px', boxShadow: '0 4px 32px rgba(0,0,0,0.4)', background: '#fff', cursor: 'zoom-out', transition: 'transform 0.2s', transform: 'scale(1.08)' }} />
        </div>
      )}
    </div>
    </div>
  );
}
export default App;
